import { combineReducers } from "redux";
import { SigninUserReducer } from "./signinUser/reducer";

export const WalletReducer = combineReducers({
  userWalletData: SigninUserReducer
});